import "./ClientRegistrationScreen.scss";
import {ITimelineStep} from "../../shared/models/common.model";
import React, {useCallback, useEffect, useRef, useState} from "react";
import _ from "lodash";
import TimeLineComponent from "../../shared/components/time-line/TimeLineComponent";
import {ImageConfig} from "../../constants";
import ClientRegistrationBasicDetailsComponent
    from "./client-registration-basic-details/ClientRegistrationBasicDetailsComponent";
import IconButtonComponent from "../../shared/components/icon-button/IconButtonComponent";
import {
    getClientBasicDetails,
    getClientCommunicationReferralDetails,
    getClientMedicalHistoryDetails
} from "../../store/actions/client.action";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import ClientRegistrationCommunicationReferralDetailsComponent
    from "./client-registration-communication-referral-details/ClientRegistrationCommunicationReferralDetailsComponent";
import LoaderComponent from "../../shared/components/loader/LoaderComponent";
import ClientRegistrationMedicalProviderDetailsComponent
    from "./client-registration-medical-provider-details/ClientRegistrationMedicalProviderDetailsComponent";
import ClientRegistrationEmergencyContactDetailsComponent
    from "./client-registration-emergency-contact-details/ClientRegistrationEmergencyContactDetailsComponent";
import ClientRegistrationMedicalHistoryQuestionnaireComponent
    from "./client-registration-medical-history-questionnaire/ClientRegistrationMedicalHistoryQuestionnaireComponent";
import {CommonService} from "../../shared/services";
import {ClientRegistrationStepKeyType} from "../../shared/models/client.model";
import {setClientRegistrationStep, setClientRegistrationSubStep} from "../../store/actions/state-management.action";
import ModalComponent from "../../shared/components/modal/ModalComponent";
import SuccessPopupComponent from "../../shared/components/success-popup/SuccessPopupComponent";
import {setFormChangesData} from "../../store/actions/form-state.action";
import ButtonComponent from "../../shared/components/button/ButtonComponent";
import ClientRegistrationWaiverAndReleaseOfLiabilityComponent
    from "./client-registration-waiver-and-release-of-liability/ClientRegistrationWaiverAndReleaseOfLiabilityComponent";


import ClientRegistrationAuthorizationToReleaseMedicalInformationComponent
    from "../client-registration-authorization-to-release-medical-information/ClientRegistrationAuthorizationToReleaseMedicalInformationComponent";
import ClientInjuryDetailsScreen from "./client-injury-details/ClientInjuryDetailsScreen";
import ClientRegistrationCertificationAndConsentComponent
    from "./client-registration-certification-and-consent/ClientRegistrationCertificationAndConsentComponent";
import ClientRegistrationPhysicalActivityQuestionnaireComponent
    from "./client-registration-physical-activity-questionnaire/ClientRegistrationPhysicalActivityQuestionnaireComponent";
import momentTimezone from "moment-timezone";
import AuthorizationDiscloseProtectedHealthInformation
    from "./authorization-to-disclose-protected-health-information/AuthorizationDiscloseProtectedHealthInformation";


interface ClientRegistrationScreenProps {

}


interface ClientRegistrationStep extends ITimelineStep {
    key: ClientRegistrationStepKeyType;
}


const oneYearExpiredFormSteps: ClientRegistrationStep[] = [
    {
        key: 'client-details',
        title: 'Client Details',
        status: 'in-progress'
    },
    {
        key: 'emergency-contact-details',
        title: 'Emergency Contact Details',
        status: 'pending'
    },
    {
        key: 'medical-provider-information',
        title: 'Medical Provider Information',
        status: 'pending'
    },
    {
        key: 'medical-history-questionnaire',
        title: 'Medical History Questionnaire',
        status: 'pending'
    },
    {
        key: 'certification-and-consent',
        title: 'Certification and Consent',
        status: 'pending'
    },
    {
        key: 'communication-preferences',
        title: 'Communication Preferences',
        status: 'pending'
    },
]

const ClientRegistrationSteps: ClientRegistrationStep[] = [
    {
        key: 'client-details',
        title: 'Client Details',
        status: 'in-progress'
    },
    {
        key: 'emergency-contact-details',
        title: 'Emergency Contact Details',
        status: 'pending'
    },
    {
        key: 'medical-provider-information',
        title: 'Medical Provider Information',
        status: 'pending'
    },
    {
        key: 'medical-history-questionnaire',
        title: 'Medical History Questionnaire',
        status: 'pending'
    },
    {
        key: 'new-injury-condition-information',
        title: 'New Injury/Condition Information',
        status: 'pending'
    },
    {
        key: 'certification-and-consent',
        title: 'Certification and Consent',
        status: 'pending'
    },
    {
        key: 'communication-preferences',
        title: 'Communication Preferences',
        status: 'pending'
    },
    {
        key: 'authorization_disclose_protected_health_information',
        title: 'Authorization to Disclose Protected Health Information',
        status: 'pending'
    },
    {
        key: 'waiver-and-release-of-liability',
        title: 'Waiver and Release of Liability ',
        status: 'pending'
    }
];

const ClientRegistrationSteps2: ClientRegistrationStep[] = [
    {
        key: 'client-details',
        title: 'Client Details',
        status: 'in-progress'
    },
    {
        key: 'emergency-contact-details',
        title: 'Emergency Contact Details',
        status: 'pending'
    },
    {
        key: 'medical-provider-information',
        title: 'Medical Provider Information',
        status: 'pending'
    },
    {
        key: 'medical-history-questionnaire',
        title: 'Medical History Questionnaire',
        status: 'pending'
    },
    {
        key: 'certification-and-consent',
        title: 'Certification and Consent',
        status: 'pending'
    },
    {
        key: 'physical-activity-questionnaire',
        title: 'Physical Activity Questionnaire',
        status: 'pending'
    },
    {
        key: 'communication-preferences',
        title: 'Communication Preferences',
        status: 'pending'
    },
    {
        key: 'authorization_disclose_protected_health_information',
        title: 'Authorization to Disclose Protected Health Information',
        status: 'pending'
    },

    {
        key: 'waiver-and-release-of-liability',
        title: 'Waiver and Release of Liability ',
        status: 'pending'
    }
];

const ClientRegistrationSteps3: ClientRegistrationStep[] = [
    {
        key: 'client-details',
        title: 'Client Details',
        status: 'in-progress'
    },
    {
        key: 'emergency-contact-details',
        title: 'Emergency Contact Details',
        status: 'pending'
    },
    {
        key: 'communication-preferences',
        title: 'Communication Preferences',
        status: 'pending'
    },
    {
        key: 'waiver-and-release-of-liability',
        title: 'Waiver and Release of Liability ',
        status: 'pending'
    }
];

const ClientRegistrationSteps4: ClientRegistrationStep[] = [
    {
        key: 'client-details',
        title: 'Client Details',
        status: 'in-progress'
    },
    {
        key: 'emergency-contact-details',
        title: 'Emergency Contact Details',
        status: 'pending'
    },
    {
        key: 'medical-provider-information',
        title: 'Medical Provider Information',
        status: 'pending'
    },
    {
        key: 'medical-history-questionnaire',
        title: 'Medical History Questionnaire',
        status: 'pending'
    },
    {
        key: 'new-injury-condition-information',
        title: 'New Injury/Condition Information',
        status: 'pending'
    },
    {
        key: 'certification-and-consent',
        title: 'Certification and Consent',
        status: 'pending'
    },
    {
        key: 'authorization_disclose_protected_health_information',
        title: 'Authorization to Disclose Protected Health Information',
        status: 'pending'
    },
];

const ClientRegistrationSteps5: ClientRegistrationStep[] = [
    {
        key: 'client-details',
        title: 'Client Details',
        status: 'in-progress'
    },
    {
        key: 'emergency-contact-details',
        title: 'Emergency Contact Details',
        status: 'pending'
    },
    {
        key: 'medical-provider-information',
        title: 'Medical Provider Information',
        status: 'pending'
    },
    {
        key: 'medical-history-questionnaire',
        title: 'Medical History Questionnaire',
        status: 'pending'
    },
    {
        key: 'certification-and-consent',
        title: 'Certification and Consent',
        status: 'pending'
    },
    {
        key: 'physical-activity-questionnaire',
        title: 'Physical Activity Questionnaire',
        status: 'pending'
    },
    {
        key: 'authorization_disclose_protected_health_information',
        title: 'Authorization to Disclose Protected Health Information',
        status: 'pending'
    },

];


const DEFAULT_STEP_KEY = 'client-details';

const ClientRegistrationScreen = (props: ClientRegistrationScreenProps) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentStep, setCurrentStep] = useState<ClientRegistrationStepKeyType | undefined>(undefined);
    const [clientRegistrationSteps, setClientRegistrationSteps] = useState<ITimelineStep[]>([]);
    const [isFormConfirmationModalOpen, setIsFormConfirmationModalOpen] = useState<boolean>(false);
    const {
        clientBasicDetails,
        isClientBasicDetailsLoading,
        clientCommunicationReferralDetails,
        isClientCommunicationReferralDetailsLoading,
        clientMedicalHistoryDetails,
        isClientMedicalHistoryDetailsLoading
    } = useSelector((state: IRootReducerState) => state.client);
    const {isFormChanges} = useSelector((state: IRootReducerState) => state.formState);

    const {
        clientRegistrationStep,
        clientRegistrationSubStep
    } = useSelector((state: IRootReducerState) => state.stateManagement);

    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const appointmentId = params.get("appointmentId");
    const [appointmentDetails, setAppointmentDetails] = useState<any>({});
    const {systemSettingsDetails} = useSelector((state: IRootReducerState) => state.user)

    const getAppointmentDetails = useCallback(() => {
        console.log(appointmentId)
        const payload = {}
        let apiCall;
        if (appointmentId) {
            apiCall = CommonService._appointment.GetUpAppointmentDetails(appointmentId, payload)
        } else {
            apiCall = CommonService._appointment.GetUpComingAppointmentDetails({timezone: momentTimezone.tz.guess()})
        }
        apiCall.then((response: any) => {
            setAppointmentDetails(response.data);
            console.log(response?.data, "Clident Resgistration form");
        })
            .catch((error: any) => {
                setAppointmentDetails(undefined);
            })

    }, [appointmentId]);

    useEffect(() => {
        getAppointmentDetails()
    }, [getAppointmentDetails]);


    useEffect(() => {
        let steps;
        if (currentUser?.is_first_login) {
            // Determine steps based on onboarding_forms_type if it’s the first login
            switch (currentUser?.onboarding_forms_type) {
                case 'therapy':
                    steps = _.cloneDeep((systemSettingsDetails?.other_settings?.waiver_enabled && !currentUser?.is_profile_completed)
                        ? ClientRegistrationSteps
                        : ClientRegistrationSteps.filter(section => section.key !== 'waiver-and-release-of-liability'));
                    break;
                case 'performance_training':
                    steps = _.cloneDeep((systemSettingsDetails?.other_settings?.waiver_enabled && !currentUser?.is_profile_completed)
                        ? ClientRegistrationSteps2
                        : ClientRegistrationSteps2.filter(section => section.key !== 'waiver-and-release-of-liability'));
                    break;
                case 'default':
                    steps = _.cloneDeep((systemSettingsDetails?.other_settings?.waiver_enabled && !currentUser?.is_profile_completed)
                        ? ClientRegistrationSteps3
                        : ClientRegistrationSteps3.filter(section => section.key !== 'waiver-and-release-of-liability'));
                    break;
                default:
                    return;
            }
        } else {
            // Determine steps based on service_category_config_type if it’s not the first login
            switch (currentUser?.onboarding_forms_type === "expired_forms" ? currentUser?.onboarding_forms_type : appointmentDetails?.service_category_config_type) {
                case 'expired_forms':
                    steps = oneYearExpiredFormSteps;
                    break;
                case 'configuration_1':
                    steps = _.cloneDeep(ClientRegistrationSteps4);
                    break;
                case 'configuration_2':
                    steps = _.cloneDeep(ClientRegistrationSteps5);
                    break;
                default:
                    return;
            }
        }

        setClientRegistrationSteps(steps);
    }, [currentUser?.is_profile_completed, currentUser?.configuration_type, currentUser?.onboarding_forms_type, currentUser?.is_first_login, appointmentDetails?.service_category_config_type, systemSettingsDetails]);


    useEffect(() => {
        if (!clientBasicDetails) {
            dispatch(getClientBasicDetails());
        }
        if (!clientCommunicationReferralDetails) {
            dispatch(getClientCommunicationReferralDetails());
        }
        if (!clientMedicalHistoryDetails) {
            dispatch(getClientMedicalHistoryDetails());
        }
    }, [dispatch, clientBasicDetails, clientMedicalHistoryDetails, clientCommunicationReferralDetails]);

    const initialStep = searchParams.get("step") as ClientRegistrationStepKeyType;
    const previousStepRef = useRef(initialStep);

    useEffect(() => {
        const step = searchParams.get("step") as ClientRegistrationStepKeyType;

        // Check if the step or clientRegistrationSteps have meaningfully changed
        const isValidStep = step && clientRegistrationSteps.some((s) => s.key === step);
        const hasStepChanged = previousStepRef.current !== step;

        if (hasStepChanged || !isValidStep) {
            if (isValidStep) {
                setCurrentStep(step);
                dispatch(setClientRegistrationStep(step));
            } else {
                searchParams.set("step", DEFAULT_STEP_KEY);
                setSearchParams(searchParams);
                setCurrentStep(DEFAULT_STEP_KEY);
                dispatch(setClientRegistrationStep(DEFAULT_STEP_KEY));
            }
            // Update the previousStepRef to the current step
            previousStepRef.current = step || DEFAULT_STEP_KEY;
        }
    }, [dispatch, searchParams, setSearchParams, clientRegistrationSteps]);


    const handleNext = useCallback(() => {
        const currentIndex = clientRegistrationSteps.findIndex((step) => step.key === currentStep);
        const nextStep = clientRegistrationSteps[currentIndex + 1];
        if (nextStep) {
            searchParams.set("step", nextStep.key);
            setSearchParams(searchParams);
            setCurrentStep(nextStep.key as ClientRegistrationStepKeyType);
            dispatch(setClientRegistrationStep(nextStep.key as ClientRegistrationStepKeyType));
        } else {
            navigate(CommonService._routeConfig.ClientRegistrationConsent());
        }
    }, [dispatch, navigate, currentStep, searchParams, setSearchParams, clientRegistrationSteps]);

    useEffect(() => {
        const currentStepIndex = clientRegistrationSteps.findIndex((step) => step.key === currentStep);

        setClientRegistrationSteps((prevState) => {
            const updatedSteps = _.cloneDeep(prevState);
            updatedSteps.forEach((step, index) => {
                if (index < currentStepIndex) {
                    step.status = 'completed';
                } else if (index === currentStepIndex) {
                    step.status = 'in-progress';
                } else {
                    step.status = 'pending';
                }
            });
            return updatedSteps;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep, dispatch]);


    // const handleStepClick = useCallback((step: ITimelineStep) => {
    //     const stepKey = (step as ClientRegistrationStep).key;
    //     // Add necessary conditions for step validation
    //     if (stepKey) {
    //         searchParams.set("step", stepKey);
    //         setSearchParams(searchParams);
    //         setCurrentStep(stepKey);
    //         dispatch(setClientRegistrationStep(stepKey));
    //     }
    // }, [dispatch, searchParams, setSearchParams]);

    const handlePrev = useCallback((isContinueTriggered?: boolean) => {
        if (!isFormChanges || isContinueTriggered) {
            let nextStep = '';
            let nextSubStep = '';
            if (currentUser?.onboarding_forms_type === 'therapy' && currentUser?.is_first_login) {
                if (clientRegistrationStep === 'client-details') {
                    if (clientRegistrationSubStep === 'personal-details') {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                        return;
                    } else if (clientRegistrationSubStep === 'contact-information') {
                        nextSubStep = 'personal-details';
                    } else if (clientRegistrationSubStep === 'address-information') {
                        nextSubStep = 'contact-information';
                    } else if (clientRegistrationSubStep === 'work-information') {
                        nextSubStep = 'address-information';
                    } else {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                    }
                } else if (clientRegistrationStep === 'emergency-contact-details') {
                    nextStep = 'client-details';
                    nextSubStep = 'work-information';
                } else if (clientRegistrationStep === 'medical-provider-information') {
                    nextStep = 'emergency-contact-details';
                } else if (clientRegistrationStep === 'medical-history-questionnaire') {
                    if (clientRegistrationSubStep === 'personal-habits') {
                        nextStep = 'medical-provider-information';
                    } else if (clientRegistrationSubStep === 'medication-supplements') {
                        nextSubStep = 'personal-habits';
                    } else if (clientRegistrationSubStep === 'allergies') {
                        nextSubStep = 'medication-supplements';
                    } else if (clientRegistrationSubStep === 'medical-history') {
                        nextSubStep = 'allergies';
                    } else if (clientRegistrationSubStep === 'female-only') {
                        nextSubStep = 'medical-history';
                    } else if (clientRegistrationSubStep === 'surgical-history') {
                        if (clientBasicDetails && clientBasicDetails?.gender === 'female') {
                            nextSubStep = 'female-only';
                        } else {
                            nextSubStep = 'medical-history';
                        }
                    } else if (clientRegistrationSubStep === 'musculoskeletal-history') {
                        nextSubStep = 'surgical-history';
                    } else {
                        nextStep = 'emergency-contact-details';
                    }
                } else if (clientRegistrationStep === 'new-injury-condition-information') {
                    nextStep = 'medical-history-questionnaire'
                    nextSubStep = 'musculoskeletal-history'
                } else if (clientRegistrationStep === 'certification-and-consent') {
                    nextStep = 'new-injury-condition-information'
                } else if (clientRegistrationStep === 'communication-preferences') {
                    nextStep = 'certification-and-consent'
                } else if (clientRegistrationStep === 'authorization_disclose_protected_health_information') {
                    nextStep = 'communication-preferences'
                } else if (clientRegistrationStep === 'waiver-and-release-of-liability') {
                    nextStep = 'authorization_disclose_protected_health_information'
                }
            } else if (currentUser?.onboarding_forms_type === 'performance_training' && currentUser?.is_first_login) {
                if (clientRegistrationStep === 'client-details') {
                    if (clientRegistrationSubStep === 'personal-details') {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                        return;
                    } else if (clientRegistrationSubStep === 'contact-information') {
                        nextSubStep = 'personal-details';
                    } else if (clientRegistrationSubStep === 'address-information') {
                        nextSubStep = 'contact-information';
                    } else if (clientRegistrationSubStep === 'work-information') {
                        nextSubStep = 'address-information';
                    } else {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                    }
                } else if (clientRegistrationStep === 'emergency-contact-details') {
                    nextStep = 'client-details';
                    nextSubStep = 'work-information';
                } else if (clientRegistrationStep === 'medical-provider-information') {
                    nextStep = 'emergency-contact-details';
                } else if (clientRegistrationStep === 'medical-history-questionnaire') {
                    if (clientRegistrationSubStep === 'personal-habits') {
                        nextStep = 'medical-provider-information';
                    } else if (clientRegistrationSubStep === 'medication-supplements') {
                        nextSubStep = 'personal-habits';
                    } else if (clientRegistrationSubStep === 'allergies') {
                        nextSubStep = 'medication-supplements';
                    } else if (clientRegistrationSubStep === 'medical-history') {
                        nextSubStep = 'allergies';
                    } else if (clientRegistrationSubStep === 'female-only') {
                        nextSubStep = 'medical-history';
                    } else if (clientRegistrationSubStep === 'surgical-history') {
                        if (clientBasicDetails && clientBasicDetails?.gender === 'female') {
                            nextSubStep = 'female-only';
                        } else {
                            nextSubStep = 'medical-history';
                        }
                    } else if (clientRegistrationSubStep === 'musculoskeletal-history') {
                        nextSubStep = 'surgical-history';
                    } else {
                        nextStep = 'emergency-contact-details';
                    }
                } else if (clientRegistrationStep === 'physical-activity-questionnaire') {
                    nextStep = 'certification-and-consent'
                } else if (clientRegistrationStep === 'certification-and-consent') {
                    nextStep = 'medical-history-questionnaire'
                    nextSubStep = 'musculoskeletal-history'
                } else if (clientRegistrationStep === 'authorization_disclose_protected_health_information') {
                    nextStep = 'communication-preferences'
                } else if (clientRegistrationStep === 'communication-preferences') {
                    nextStep = 'physical-activity-questionnaire'
                } else if (clientRegistrationStep === 'waiver-and-release-of-liability') {
                    nextStep = 'authorization_disclose_protected_health_information'
                }
            } else if (currentUser?.onboarding_forms_type === 'default') {
                if (clientRegistrationStep === 'client-details') {
                    if (clientRegistrationSubStep === 'personal-details') {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                        return;
                    } else if (clientRegistrationSubStep === 'contact-information') {
                        nextSubStep = 'personal-details';
                    } else if (clientRegistrationSubStep === 'address-information') {
                        nextSubStep = 'contact-information';
                    } else if (clientRegistrationSubStep === 'work-information') {
                        nextSubStep = 'address-information';
                    } else {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                    }
                } else if (clientRegistrationStep === 'emergency-contact-details') {
                    nextStep = 'client-details';
                    nextSubStep = 'work-information';
                } else if (clientRegistrationStep === 'communication-preferences') {
                    nextStep = 'emergency-contact-details';
                } else if (clientRegistrationStep === 'waiver-and-release-of-liability') {
                    nextStep = 'communication-preferences';
                }
            } else if (appointmentDetails?.service_category_config_type === 'configuration_1' && !currentUser?.is_first_login) {
                if (clientRegistrationStep === 'client-details') {
                    if (clientRegistrationSubStep === 'personal-details') {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                        return;
                    } else if (clientRegistrationSubStep === 'contact-information') {
                        nextSubStep = 'personal-details';
                    } else if (clientRegistrationSubStep === 'address-information') {
                        nextSubStep = 'contact-information';
                    } else if (clientRegistrationSubStep === 'work-information') {
                        nextSubStep = 'address-information';
                    } else {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                    }
                } else if (clientRegistrationStep === 'emergency-contact-details') {
                    nextStep = 'client-details';
                    nextSubStep = 'work-information';
                } else if (clientRegistrationStep === 'medical-provider-information') {
                    nextStep = 'emergency-contact-details';
                } else if (clientRegistrationStep === 'medical-history-questionnaire') {
                    if (clientRegistrationSubStep === 'personal-habits') {
                        nextStep = 'medical-provider-information';
                    } else if (clientRegistrationSubStep === 'medication-supplements') {
                        nextSubStep = 'personal-habits';
                    } else if (clientRegistrationSubStep === 'allergies') {
                        nextSubStep = 'medication-supplements';
                    } else if (clientRegistrationSubStep === 'medical-history') {
                        nextSubStep = 'allergies';
                    } else if (clientRegistrationSubStep === 'female-only') {
                        nextSubStep = 'medical-history';
                    } else if (clientRegistrationSubStep === 'surgical-history') {
                        if (clientBasicDetails && clientBasicDetails?.gender === 'female') {
                            nextSubStep = 'female-only';
                        } else {
                            nextSubStep = 'medical-history';
                        }
                    } else if (clientRegistrationSubStep === 'musculoskeletal-history') {
                        nextSubStep = 'surgical-history';
                    } else {
                        nextStep = 'emergency-contact-details';
                    }
                } else if (clientRegistrationStep === 'new-injury-condition-information') {
                    nextStep = 'medical-history-questionnaire'
                    nextSubStep = 'musculoskeletal-history'
                } else if (clientRegistrationStep === 'certification-and-consent') {
                    console.log("my stepp")
                    nextStep = 'new-injury-condition-information'
                } else if (clientRegistrationStep === 'authorization_disclose_protected_health_information') {
                    nextStep = 'certification-and-consent'
                }
            } else if (appointmentDetails?.service_category_config_type === 'configuration_2' && !currentUser?.is_first_login) {
                if (clientRegistrationStep === 'client-details') {
                    if (clientRegistrationSubStep === 'personal-details') {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                        return;
                    } else if (clientRegistrationSubStep === 'contact-information') {
                        nextSubStep = 'personal-details';
                    } else if (clientRegistrationSubStep === 'address-information') {
                        nextSubStep = 'contact-information';
                    } else if (clientRegistrationSubStep === 'work-information') {
                        nextSubStep = 'address-information';
                    } else {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                    }
                } else if (clientRegistrationStep === 'emergency-contact-details') {
                    nextStep = 'client-details';
                    nextSubStep = 'work-information';
                } else if (clientRegistrationStep === 'medical-provider-information') {
                    nextStep = 'emergency-contact-details';
                } else if (clientRegistrationStep === 'medical-history-questionnaire') {
                    if (clientRegistrationSubStep === 'personal-habits') {
                        nextStep = 'medical-provider-information';
                    } else if (clientRegistrationSubStep === 'medication-supplements') {
                        nextSubStep = 'personal-habits';
                    } else if (clientRegistrationSubStep === 'allergies') {
                        nextSubStep = 'medication-supplements';
                    } else if (clientRegistrationSubStep === 'medical-history') {
                        nextSubStep = 'allergies';
                    } else if (clientRegistrationSubStep === 'female-only') {
                        nextSubStep = 'medical-history';
                    } else if (clientRegistrationSubStep === 'surgical-history') {
                        if (clientBasicDetails && clientBasicDetails?.gender === 'female') {
                            nextSubStep = 'female-only';
                        } else {
                            nextSubStep = 'medical-history';
                        }
                    } else if (clientRegistrationSubStep === 'musculoskeletal-history') {
                        nextSubStep = 'surgical-history';
                    } else {
                        nextStep = 'emergency-contact-details';
                    }
                } else if (clientRegistrationStep === 'physical-activity-questionnaire') {
                    nextStep = 'certification-and-consent';
                } else if (clientRegistrationStep === 'certification-and-consent') {

                    nextStep = 'medical-history-questionnaire'
                    nextSubStep = 'musculoskeletal-history'

                } else if (clientRegistrationStep === 'authorization_disclose_protected_health_information') {
                    nextStep = 'physical-activity-questionnaire'
                }
            }
            if (currentUser?.onboarding_forms_type === 'expired_forms' && currentUser?.is_first_login) {
                if (clientRegistrationStep === 'client-details') {
                    if (clientRegistrationSubStep === 'personal-details') {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                        return;
                    } else if (clientRegistrationSubStep === 'contact-information') {
                        nextSubStep = 'personal-details';
                    } else if (clientRegistrationSubStep === 'address-information') {
                        nextSubStep = 'contact-information';
                    } else if (clientRegistrationSubStep === 'work-information') {
                        nextSubStep = 'address-information';
                    } else {
                        navigate(CommonService._routeConfig.ClientOnboarding());
                    }
                } else if (clientRegistrationStep === 'emergency-contact-details') {
                    nextStep = 'client-details';
                    nextSubStep = 'work-information';
                } else if (clientRegistrationStep === 'medical-provider-information') {
                    nextStep = 'emergency-contact-details';
                } else if (clientRegistrationStep === 'medical-history-questionnaire') {
                    if (clientRegistrationSubStep === 'personal-habits') {
                        nextStep = 'medical-provider-information';
                    } else if (clientRegistrationSubStep === 'medication-supplements') {
                        nextSubStep = 'personal-habits';
                    } else if (clientRegistrationSubStep === 'allergies') {
                        nextSubStep = 'medication-supplements';
                    } else if (clientRegistrationSubStep === 'medical-history') {
                        nextSubStep = 'allergies';
                    } else if (clientRegistrationSubStep === 'female-only') {
                        nextSubStep = 'medical-history';
                    } else if (clientRegistrationSubStep === 'surgical-history') {
                        if (clientBasicDetails && clientBasicDetails?.gender === 'female') {
                            nextSubStep = 'female-only';
                        } else {
                            nextSubStep = 'medical-history';
                        }
                    } else if (clientRegistrationSubStep === 'musculoskeletal-history') {
                        nextSubStep = 'surgical-history';
                    } else {
                        nextStep = 'emergency-contact-details';
                    }
                } else if (clientRegistrationStep === 'certification-and-consent') {
                    nextStep = 'medical-history-questionnaire'
                } else if (clientRegistrationStep === 'communication-preferences') {
                    nextStep = 'certification-and-consent'
                }
            }
            if (nextStep) {
                searchParams.set("step", nextStep);
                dispatch(setClientRegistrationStep(nextStep as ClientRegistrationStepKeyType));
            }
            if (nextSubStep) {
                searchParams.set("subStep", nextSubStep);
                dispatch(setClientRegistrationSubStep(nextSubStep));
            }
            setSearchParams(searchParams);
        } else {
            setIsFormConfirmationModalOpen(true);
        }
    }, [appointmentDetails?.service_category_config_type, searchParams, navigate, currentUser, clientBasicDetails, clientRegistrationStep, clientRegistrationSubStep, setSearchParams, isFormChanges, dispatch]);

    useEffect(() => {
        if (clientRegistrationStep) {
            setCurrentStep(clientRegistrationStep);
        }
    }, [searchParams, setSearchParams, clientRegistrationStep]);

    return (
        <div className={'client-registration-screen'}>
            <div className="client-registration-container">
                <div className="client-registration-logo-time-line">
                    <div className="client-registration-logo">
                        ZOELLA
                    </div>
                    <div className="client-registration-timeline">
                        <TimeLineComponent steps={clientRegistrationSteps}/>
                    </div>
                </div>
                <div className="client-registration-form-container">
                    <div className="client-registration-form-back-navigation" onClick={() => handlePrev(true)}>
                        <IconButtonComponent className="client-registration-form-back-navigation_icon">
                            <ImageConfig.NavigateBack/>
                        </IconButtonComponent>
                        <div className="client-registration-form-back-navigation_text">
                            Previous
                        </div>
                    </div>
                    <div className="client-registration-form-wrapper">
                        {
                            currentStep === 'client-details' &&
                            <ClientRegistrationBasicDetailsComponent onNext={handleNext}
                                                                     appointmentId={appointmentId ? appointmentId : appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'communication-preferences' &&
                            <ClientRegistrationCommunicationReferralDetailsComponent onNext={handleNext}
                                                                                     appointmentId={appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'emergency-contact-details' &&
                            <ClientRegistrationEmergencyContactDetailsComponent onNext={handleNext}
                                                                                appointmentId={appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'medical-provider-information' &&
                            <ClientRegistrationMedicalProviderDetailsComponent onNext={handleNext}
                                                                               appointmentId={appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'medical-history-questionnaire' &&
                            <ClientRegistrationMedicalHistoryQuestionnaireComponent onNext={handleNext}
                                                                                    appointmentId={appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'physical-activity-questionnaire' &&
                            <ClientRegistrationPhysicalActivityQuestionnaireComponent onNext={handleNext}
                                                                                      appointmentId={appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'new-injury-condition-information' &&
                            <ClientInjuryDetailsScreen onNext={handleNext} appointmentId={appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'certification-and-consent' &&
                            <ClientRegistrationCertificationAndConsentComponent onNext={handleNext}
                                                                                appointmentId={appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'authorization-to-release-medical-information' &&
                            <ClientRegistrationAuthorizationToReleaseMedicalInformationComponent onNext={handleNext}
                                                                                                 appointmentId={appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'authorization_disclose_protected_health_information' &&
                            <AuthorizationDiscloseProtectedHealthInformation onNext={handleNext}
                                                                             appointmentId={appointmentDetails?._id}/>
                        }
                        {
                            currentStep === 'waiver-and-release-of-liability' &&
                            <ClientRegistrationWaiverAndReleaseOfLiabilityComponent onNext={handleNext}
                                                                                    appointmentId={appointmentDetails?._id}/>
                        }
                    </div>
                </div>
                {
                    (isClientBasicDetailsLoading || isClientCommunicationReferralDetailsLoading || isClientMedicalHistoryDetailsLoading) &&
                    <div className={"client-registration-loading-wrapper"}>
                        <LoaderComponent type={"spinner"}/>
                    </div>
                }
            </div>

            <ModalComponent isOpen={isFormConfirmationModalOpen}
                            size={'xs'}
                            className=""
                            onClose={() => setIsFormConfirmationModalOpen(false)}>
                <div className="modal__content">
                    <SuccessPopupComponent
                        title={'Save your details?'}
                        description={`Are you sure you want to go Back? If so, please press "continue"\n to save your data and return to the previous page.`}
                        imageData={ImageConfig.PopupLottie}
                        showLottie={true}
                        actions={<>
                            <div className={'success-popup-continue-and-cancel-cta'}>
                                <ButtonComponent
                                    className="mrg-right-10"
                                    variant={"outlined"}
                                    fullWidth={true}
                                    color={"default"}
                                    onClick={() => setIsFormConfirmationModalOpen(false)}>Cancel</ButtonComponent>
                                <ButtonComponent
                                    className="mrg-left-10"
                                    fullWidth={true}

                                    onClick={() => {
                                        dispatch(setFormChangesData(false));
                                        setIsFormConfirmationModalOpen(false)
                                        handlePrev(true);
                                    }}
                                >Continue</ButtonComponent>
                            </div>
                        </>}
                    />
                </div>
            </ModalComponent>
        </div>
    );

};

export default ClientRegistrationScreen;
